// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"i5-z","displaySixCardTiles":"j5-z"};